<template>
  <div>
    <p>Podrobný výpis hovorů</p>
    <div class="cdr-link-button" v-for="link in linkList" :key="link.year + link.month">
      <div class="btn-group">
          <a :href="link.enabled ? ('/api/ipexcdrfiles/'+number+'-'+link.year+'-'+link.month+'.html') : false" class="btn btn-info" :class="{'disabled': !link.enabled}">
            {{ czech_month_name(link.month) }} {{ link.year }}
          </a>
          <button type="button" class="btn btn-info dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="!link.enabled">
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <div class="dropdown-menu">
            <a class="dropdown-item" :href="'/api/ipexcdrfiles/'+number+'-'+link.year+'-'+link.month+'.csv'">Stáhnout CSV</a>
          </div>
      </div>
      <small v-if="is_this_month(link)">
        <br>
        platí k {{ valid_as_of_formatted(link.fileValidAsOf) }}
      </small>
    </div>
	</div>
</template>

<script>

import moment from 'moment'
import axios from 'axios'

export default {
  name: 'ipex-cdrfiles-links',
  props: ['number'],
  data () {
    return {
      linkList: []
    }
  },
  created: function () {
    let now = moment()
    for (var i = 0; i < 6; i++) {
      this.linkList.push({year: now.format('Y'), month: now.format('M'), enabled: false})
      now.subtract(1, 'month')
    }
    this.test_cdrs_available()
  },
  methods: {
    czech_month_name: function (m) {
      let monthNames = ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec']
      return monthNames[m - 1]
    },
    test_cdrs_available: function () {
      for (let link of this.linkList) {
        axios.get('/api/ipexcdrfiles/' + this.number + '-' + link.year + '-' + link.month + '/exists')
        .then((response) => {
          console.log(this.number, link.year, link.month, response.status, response.data)
          if (response.status === 200) {
            link.enabled = true
            link.fileValidAsOf = response.data.valid_as_of
          }
        })
      }
    },
    valid_as_of_formatted (timestamp) {
      return moment(timestamp).format('D.M. H:m')
    },
    is_this_month (link) {
      let today = new Date()
      return link.year === today.getFullYear() && link.month === today.getMonth() + 1
    }
  }
}
</script>

<style scoped>
.cdr-link-button {
  margin: 5px;
  display: inline-block;
  vertical-align: top;
  text-align: center;
}
.cdr-link-button small {
  color: gray;
}
</style>



// WEBPACK FOOTER //
// IpexCdrFilesLinks.vue?218ff064